import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CategoryDashboard.css';


const CompressionCate = () => {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState({ name: '' });
    const [editCategory, setEditCategory] = useState(null);
    const API_URL = 'https://snapper.hxbindia.com/compression';

    // Fetch categories
    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(API_URL);
            setCategories(response.data);
            console.log(response.data)
        } catch (error) {
            toast.error('Failed to fetch categories');
        }
    };

 

    const handleAddCategory = async () => {
        try {
            await axios.post(API_URL, { name: newCategory.name }, {
                headers: { 'Content-Type': 'application/json' },
            });
            toast.success('Category added successfully');
            setNewCategory({ name: '' });
            fetchCategories();
        } catch (error) {
            console.error("Error adding category:", error.response?.data);
            toast.error(error.response?.data?.error || 'Failed to add category');
        }
    };
    

    // Update a category
    const handleUpdateCategory = async () => {
        const formData = new FormData();
        formData.append('name', editCategory.name);
       

        try {
            await axios.put(`${API_URL}/${editCategory._id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            toast.success('Category updated successfully');
            setEditCategory(null);
            fetchCategories();
        } catch (error) {
            toast.error('Failed to update category');
        }
    };

    // Delete a category
    const handleDeleteCategory = async (id) => {
        try {
            await axios.delete(`${API_URL}/${id}`);
            toast.success('Category deleted successfully');
            fetchCategories();
        } catch (error) {
            toast.error('Failed to delete category');
        }
    };

    return (
        <div className="container">

            <h1>Admin Panel</h1>
            <hr />
            <ToastContainer />
            <h4>Category Dashboard</h4>

            {/* Add Category Form */}
            <div className='card'>
                <div className="card-body">
                <h3 style={{ textAlign: "center", color: "#333", marginBottom: "15px" }}>Add New Category</h3>

                <input
                    type="text"
                    placeholder="Name" class="form-control"
                    value={newCategory.name}
                    onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                    style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", marginBottom: "10px" }}
                />

               

                <button className='btn btn-gradient-primary me-2'
                    onClick={handleAddCategory}
                    style={{
                        width: "100%",
                        padding: "10px",
                        backgroundColor: "#28a745",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "16px",
                        transition: "background 0.3s", 
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
                >
                    Add Category
                </button>
            </div>

            {/* Edit Category */}
            {editCategory && (
                <div>
                    <h4>Edit Category</h4>
                    <input
                        type="text"
                        value={editCategory.name}
                        onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })}
                    />
                  
                    <button onClick={handleUpdateCategory}>Update Category</button>
                    <button onClick={() => setEditCategory(null)}>Cancel</button>
                </div>
            )}

            {/* Category List */}
            <h4>Category List</h4>

            <div className="row ">

                <div class="col-lg-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body table-responsive">

                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories.map((category) => (
                                        <tr key={category._id}>
                                            <td>{category.name}</td>
                                            
                                            <td>
                                                <button onClick={() => setEditCategory(category)} className='btn btn-primary'>Edit</button>
                                               
                                            </td>
                                            <td>
                                               
                                                <button onClick={() => handleDeleteCategory(category._id)} className='btn btn-danger ms-2'>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div></div>
            </div>

        </div></div>
    );
};

export default CompressionCate;
